<template>
  <!-- 通用模块 >>> 导入 >>> @todo 导入复杂表头的场景未处理!!! -->
  <div>
    <!-- niTM能不能取个有意义的class cnm -->
    <el-dialog
      v-if="show"
      class="import_page table_batch_import_dia"
      v-dialogDrag
      lock-scroll
      title="导入Excel"
      append-to-body
      :show-close="false"
      :visible.sync="show"
      :close-on-click-modal="false"
    >
      <!-- 外部弹窗：顶部 -->
      <div slot="title" class="reports_title_box">
        <div class="reports_title">
          导入Excel
        </div>
        <div class="reports_title_btn">
          <div class="help">
            <!-- <svg-icon icon-class="wenhao" class="icons" /> -->
          </div>
          <i
            class="el-icon-close"
            v-preventReClick
            @click="show = false"
            style="font-weight: bold"
          />
        </div>
      </div>

      <!-- 外部弹窗内容部分 -->
      <div class="content">
        <el-tabs v-model="activeTab">
          <!-- 导入excel内容 -->
          <el-tab-pane label="Excel表内容" name="tabelcontent">
            <!-- ps:这里要用v-show，否则无法调用 importExcel() 事件 -->
            <UploadExcel
              v-show="!tableHeader.length && !tableData.length"
              ref="uploadExcel"
              :on-success="handleSuccess"
            >
              <div class="msg">
                <!-- <svg-icon icon-class="warn" />&nbsp;请选择Excel文件导入！ -->
                <svg-icon icon-class="upload" />
                <p>拖拽至此或点击选择EXCEL上传表格</p>
                <p>（支持格式：.xls .xlsx）</p>
              </div>
            </UploadExcel>
            <el-table
              v-loading="loading"
              v-show="tableHeader.length || tableData.length"
              ref="contentTable"
              border
              :key="mainTableKey"
              stripe
              height="800"
              highlight-current-row
              :fit="false"
              :data="tableData"
              tooltip-effect="dark"
              @cell-dblclick="modifyTable"
            >
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column
                :render-header="h => renderHeaderA(h, index, item)"
                v-for="(item, index) in tableHeader"
                :key="index"
                width="150px"
                :prop="item"
                :label="item"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div
                    v-show="isModify !== scope.row"
                    :class="{ error: failTitleField.includes(item) }"
                  >
                    <!-- 2023 05 24 前端只显示2为小数 -->
                    {{ scope.row[item] }}&nbsp;
                  </div>
                  <el-input
                    v-show="isModify === scope.row"
                    v-model="scope.row[item]"
                    placeholder="请输入内容"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="page">
          <el-pagination
            class="importPage"
            small
            :current-page="importObj[activeTab].currentPage"
            :page-sizes="[10, 20, 50, 100, 200, 300, 400, 500]"
            :page-size="importObj[activeTab].pageSize"
            layout="prev, pager, next,sizes,total"
            :total="importObj[activeTab].pageTotal"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <!-- 外部弹窗：底部 -->
      <div slot="footer" class="dialog_footer">
        <div class="footer_search_box">
          <template v-if="activeTab === 'tabelcontent'">
            <el-button type="primary" v-preventReClick @click="importExcel">
              选择Excel
            </el-button>
            <el-button v-preventReClick @click="show = false">
              退出
            </el-button>
          </template>
        </div>
        <div class="footer_btns">
          <el-button
            type="primary"
            :disabled="tableHeader.length === 0"
            :loading="loading"
            v-preventReClick
            @click="upload"
            >保存数据</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import UploadExcel from '@components/uploadExcel'
import SaveTypeQuery from './saveTypeQuery'
import { paging } from '@/assets/js/pubMethods.js'
// import SelectHeader from '@v8/common/selectImportHeader'
import { createGguid, exportExcel, drag } from '@/assets/js/pubMethods'
// import { getCommProcess, stopCommProcess } from '@api/user'
// import bus from '@/views/v8/bus/commonBus.js'
export default {
  components: { UploadExcel, SaveTypeQuery },
  directives: {
    // 指令
    dialogDrag: {
      bind: drag // 实现拖拽
    }
  },
  props: {
    moduleConfig: {
      type: Object,
      default: () => {}
    },
    close: {
      // 通知 toolbar.vue 清空激活的组件 跟 watch 中的 show 一并使用
      type: Function,
      default: () => {
        console.error(`**${this.active}模块未设置close方法**`)
      }
    },
    mautoid: {
      type: [String, Number],
      default: '0'
    },
    type: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      // orgList: [], //用来存储导入的excel所有数据
      // bigArray: [], //用来装分页后的数据
      // pageSize: 10,
      // currentPage: 1,
      // pageTotal: 0,
      importObj: {
        tabelcontent: {
          orgList: [],
          bigArray: [],
          pageSize: 10,
          currentPage: 1,
          pageTotal: 0
        },
        failTable: {
          orgList: [],
          bigArray: [],
          pageSize: 10,
          currentPage: 1,
          pageTotal: 0
        }
      },
      userClosePro: false, // 用户主动关闭进度条弹窗
      total: 0, // 进度条 总数
      percent: 0,
      curChecking: 0,
      mainTableKey: 1,
      show: false, // 测试专用，用完请改回false
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {}, // 用户登录信息
      reportSrc: require('@assets/img/reportsForm.png'),
      activeTab: 'tabelcontent', // tabelcontent:Excel表内容, failTable:导入失败的内容
      tableData: [], // 表格数据
      tableHeader: [], // 表头数据
      reqNum: 0, // 保存成功过的次数（用于判断是否需要刷新table.vue）
      startStatus: [],
      chooseHead: {},
      filters: [], // 过滤数据
      titleFormat: [], // 标题格式（请求后）
      failTitleField: [], // 不符合格式的表头字段
      failHeader: [], // 导入失败的标题
      failTableData: [], // 导入失败的数据
      guid: null, // 唯一标识
      Timer: null, // 定时获取上传进度
      loading: false,
      isModify: null, // 双击选中的一行
      firstDateTimes: '',
      lastDateTimes: ''
    }
  },
  computed: {
    cansave() {
      // 是否允许 保存数据 [存在符合格式的数据]
      return (
        this.tableData.length &&
        this.tableData.length > this.failTableData.length
      )
    },
    canExport() {
      // 是否允许 导出数据
      return (
        (this.activeTab === 'tabelcontent' && this.tableHeader.length > 0) ||
        (this.activeTab === 'failTable' && this.failTableData.length > 0)
      )
    }
  },
  watch: {
    show(n) {
      if (n) {
        this.init()
        this.pageInit()
      } else {
        this.close()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let pageEl = document.querySelectorAll('.importPage')
      pageEl.forEach(el => {
        el.children[3].children[0].addEventListener('click', function() {
          let dropEl = document.querySelectorAll('.el-select-dropdown__list')
          dropEl[2].children[4].innerText = '所有记录'
          console.log(dropEl, 'dropEl')
        })
      })
    })

    this.getExportFields()
  },
  created() {},
  methods: {
    // 分页数据初始化
    pageInit() {
      let o = {
        tabelcontent: {
          orgList: [],
          bigArray: [],
          pageSize: 10,
          currentPage: 1,
          pageTotal: 0
        },
        failTable: {
          orgList: [],
          bigArray: [],
          pageSize: 10,
          currentPage: 1,
          pageTotal: 0
        }
      }
      Object.assign(this.importObj, o)
    },
    // 改变页数
    handleSizeChange(val) {
      if (this.tableData.length > 0) {
        let o = this.importObj[this.activeTab]
        o.bigArray = []
        this.loading = true
        if (val >= 10) {
          o.pageSize = val
        } else {
          o.pageSize = this.importObj[this.activeTab].orgList.length
        }
        o.bigArray = paging(o.pageSize, o.orgList)
        if (o.bigArray.length > 0) {
          this.loading = false
        }
        let ary = o.bigArray[o.currentPage - 1]
        if (this.activeTab == 'tabelcontent') {
          this.tableData = ary
        } else if (this.activeTab == 'failTable') {
          this.failTableData = ary
        }
      }
    },
    // 改变当前页
    handleCurrentChange(val) {
      if (this.tableData.length > 0) {
        this.importObj[this.activeTab].currentPage = val
        let ary = this.importObj[this.activeTab].bigArray[
          this.importObj[this.activeTab].currentPage - 1
        ]
        if (this.activeTab == 'tabelcontent') {
          this.tableData = ary
        } else if (this.activeTab == 'failTable') {
          this.failTableData = ary
        }
      }
    },

    // 获取导出Excel字段列表
    getExportFields() {},
    init() {
      // 初始化
      this.tableData = []
      this.tableHeader = []

      this.activeTab = 'tabelcontent'
      this.titleFormat = []
      this.failTitleField = []
      this.failHeader = []
      this.failTableData = []
      this.guid = null
      this.curUploadIdx = 0
      this.percent = 0
    },
    // 选择要导入的excel
    importExcel() {
      this.loading = true
      this.$refs.uploadExcel && this.$refs.uploadExcel.handleUpload()
    },
    // 导入成功 回调
    handleSuccess({ results, header, excelName }) {
      // 初始化数据
      this.init()
      // 处理results，去除keys里的换行
      let newResults = []
      let resultKeys = header.length > 0 ? header : Object.keys(results[0])
      results.forEach(item => {
        let obj = {}
        for (let k = 0; k < resultKeys.length; k++) {
          obj[
            resultKeys[k] ? resultKeys[k].replace(/\n/g, '') : resultKeys[k]
          ] =
            item[resultKeys[k]] || item[resultKeys[k]] == 0
              ? item[resultKeys[k]]
              : null
        }
        newResults.push(obj)
      })
      // 对比导入的标题格式
      // 用新数组接收去掉换行的头
      let newHerder = []
      header.forEach(it => {
        it = it ? it.replace(/\n/g, '') : it
        newHerder.push(it)
      })
      this.compareTitleFormat(newHerder.join(','), newResults)
      // const h = header.map(item => {
      //   return {
      //     prop: item,
      //     label: item
      //   }
      // })

      this.importObj[this.activeTab].orgList = newResults
      this.importObj[this.activeTab].pageTotal = this.importObj[
        this.activeTab
      ].orgList.length
      this.importObj[this.activeTab].bigArray = paging(
        this.importObj[this.activeTab].pageSize,
        newResults
      )
      this.tableData = this.importObj[this.activeTab].bigArray[
        this.importObj[this.activeTab].currentPage - 1
      ]
      this.tableHeader = newHerder // header;
      // this.fileName = excelName // 作废
      this.loading = false
    },
    // 对比导入的标题格式
    compareTitleFormat(title, list) {},
    // // 上传数据
    // upload(type) {
    //   // this.titleFormat  [{fieldname: "isactive", title: "isactive"}, ...]
    //   // this.tableData [{isactive: "true"}, ...]
    //   const list = []

    //   this.importObj[this.activeTab].orgList.forEach(item => {
    //     var obj = {}
    //     for (const k in item) {
    //       const field = this.titleFormat.find(it => it.title === k) // 筛选出 key -> value 对照关系
    //       if (field && field.fieldname) {
    //         // 只有符合要求的字段才上传到后台，否则很多个{ '': value }
    //         obj[field.fieldname] = item[k]
    //       }
    //     }
    //     if (Object.keys(obj).length > 0) {
    //       list.push(obj)
    //     }
    //   })
    //   if (list.length === 0) {
    //     // this.$confirm('当前没有找到符合格式的数据，确定要保存数据吗？',
    //     this.$alert(
    //       '当前没有找到符合格式的数据，请重新编辑后再上传！',
    //       '系统信息',
    //       {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }
    //     )
    //   } else {
    //     const newList = []
    //     list.forEach(item => {
    //       // console.log(item, 666)
    //       const newObj = {}
    //       for (var key in item) {
    //         // console.log(key, item[key], 555)
    //         newObj[key] = String(item[key])
    //       }
    //       // console.log(newObj, 444)
    //       newList.push(newObj)
    //     })
    //     // this.save(type, list) // 保存数据
    //     this.save(type, newList) // 保存数据
    //   }
    // },

    // // 保存数据
    // save(type, list) {},
    // 双击让表格变为可修改状态
    modifyTable(e) {
      this.isModify = e
    },
    // 生成表头dom（文字+下拉筛选框）
    renderSpecNameHeader(createElement, { row, column, $index }) {
      const idx = $index - 2 // ps 不启用多表头的需减去2列（选择+序号）
      const self = this
      const opt = self.tableHeader.find(item => item === column.label)
      if (opt) {
        return createElement(
          'div',
          { style: 'display:flex; width:100%;' },
          // { style: `display:flex; width:${column.label.length + 4}em;` },
          [
            createElement('div', {
              domProps: {
                innerHTML: column.label
              }
            }),
            createElement(SelectHeader, {
              style: 'cursor: pointer',
              ref: 'filterHeader',
              props: {
                options: self.tableData[idx] ? self.tableHeader : [], // 下拉框选项
                fieldname: opt // 下拉框选项
              },
              // 事件监听器在 `on` 属性内，
              // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
              // 需要在处理函数中手动检查 keyCode。
              on: {
                // selectChange: self.selectChange
                // click: this.clickHandler
                close: self.filterClose
              },
              // 仅用于组件，用于监听原生事件，而不是组件内部使用
              // `vm.$emit` 触发的事件。
              nativeOn: {
                // click: this.nativeClickHandler
                click: () => {
                  self.openFilter(column, idx)
                }
              }
            })
          ]
        )
      } else {
        return null
      }
    },
    renderHeaderA(h, index, prop) {
      return h('div', [
        h(
          'el-select',
          {
            style: {
              width: '100%',
              textAlign: 'center'
            },
            on: {
              change: value => {
                this.mainTableKey = Math.random()
                // console.log(prop,'prop')
                // this.chooseHead[prop] = value

                this.tableHeader[index] = value
                //  this.tableHeader[index]=value
                this.importObj[this.activeTab].orgList.forEach(item => {
                  for (let it in item) {
                    if (it === prop) {
                      item[value] = item[it]
                      delete item[it]
                    }
                  }
                })
                this.importObj[this.activeTab].orgList = JSON.parse(
                  JSON.stringify(this.importObj[this.activeTab].orgList)
                )
                // console.log(this.importObj[this.activeTab].orgList,'this.importObj[this.activeTab].orgList')
                // console.log(this.tableHeader, "tableheader");
                // console.log(this.tableData, "this.tableData");
                // console.log(JSON.parse(JSON.stringify(this.chooseHead)), 22222222 )
                this.compareTitleFormat(
                  this.tableHeader.join(','),
                  this.importObj[this.activeTab].orgList
                )
              }
            },
            props: {
              value: this.tableHeader[index] || this.startStatus[index]
            }
          },
          [
            this.filters.map(item => {
              return h('el-option', {
                props: {
                  value: item.chnname,
                  label: item.chnname
                }
              })
            })
          ]
        )
      ])
    },
    upload() {
      // console.log(this.importObj[this.activeTab].orgList)
      let data = this.importObj[this.activeTab].orgList.map(e => {
        // console.log(e['需要研发协助'])
        return this.type == '1'
          ? {
              mautoid: this.mautoid,
              crman: this.userInfo.name,
              autoid: 0,
              phase: e['所属阶段'].trim(),
              name: e['模块分类'],
              module: e['所属模块'],
              type: e['类型'],
              taskdetail: e['明细'],
              instructions: e['任务说明'],
              fzr: e['任务负责人'],
              dy:
                e['是否调研'] == '是' ||
                e['是否调研'] == 'true' ||
                e['是否调研'] == 'True' ||
                e['是否调研'] == 'TRUE' ||
                e['是否调研'] == '1',
              sqnum: e['任务序号']
            }
          : {
              mautoid: this.mautoid,
              crman: this.userInfo.name,
              autoid: 0,
              phase: e['所属阶段'].trim() || '阶段一',
              name: e['模块分类'],
              module: e['所属模块'],
              type: e['类型'],
              taskdetail: e['任务明细'] || e['明细'],
              instructions: e['任务说明'],
              week: e['周'],
              bd: e['计划开始日期'],
              ed: e['计划结束日期'],
              days: e['持续天数'],
              findate: e['实际完成日期'],
              status: e['状态'],
              reason: e['延期原因'],
              fzr: e['任务负责人'] || e['负责人'],
              kf:
                e['需要研发协助'] == '是' ||
                e['需要研发协助'] == 'true' ||
                e['需要研发协助'] == 'True' ||
                e['需要研发协助'] == 'TRUE' ||
                e['需要研发协助'] == '1',
              sqnum: e['任务序号']
            }
      })

      // if(data.length<31) this.$emit('tableSave', '1', data)
      // else{
      while (data.length > 30) {
        //数据过程，拆分数组
        let arr = this.splitArray(data, 30)
        let cansave = arr[0]
        data = arr[1]
        // console.log(cansave, 'cansave')
        this.$emit('tableSave', '1', cansave)
      }
      // console.log(data, 'data')
      this.$emit('tableSave', '1', data)
      // }
      this.show = false
    },
    // 拆分数组
    splitArray(arr, index) {
      var firstHalf = arr.slice(0, index)
      var secondHalf = arr.slice(index)
      return [firstHalf, secondHalf]
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
// 外部弹窗

.el-dialog__wrapper.import_page {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(1200px, 700px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    margin: 0 !important;
    @include center;
    // 表头
    .el-dialog__header {
      height: 46px;
      padding: 0;
      /* color: #fff; */
      .reports_title_box {
        padding: 0 20px;
        /* background: $active-color; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include font(16px, 46px);
        .reports_title {
          font-size: 20px !important;
          font-weight: bold !important;
          display: flex;
          align-items: center;
          // img {
          //   @include wh(24px, 24px);
          //   margin-right: 6px;
          // }
          svg {
            color: $active-color;
          }
        }
        .reports_title_btn {
          display: flex;
          align-items: center;
          .help,
          .el-icon-close {
            padding: 0 5px;
            @include font(14px, 46px);
            cursor: pointer;
          }
        }
      }
    }
    // 主体
    .el-dialog__body {
      padding: 0;
      flex: 1;
      overflow: hidden;
      margin-top: -15px !important;
      .content {
        height: 100%;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        .el-tabs {
          @include wh(100%, 100%);
          overflow: auto;
          display: flex;
          flex-direction: column;
          // 头
          .el-tabs__header {
            .el-tabs__nav-wrap {
              .el-tabs__nav-scroll {
                .el-tabs__nav {
                  .el-tabs__item {
                    height: 50px;
                    line-height: 50px;
                  }
                  #tab-failTable {
                    color: $error-color;
                  }
                  #tab-failTable.is-disabled {
                    color: #909399;
                  }
                }
              }
            }
          }
          // 内容
          .el-tabs__content {
            flex: 1;

            // @todo
            .el-tab-pane {
              overflow: auto;
              // @include wh(100%, 100%);
              height: calc(100% - 46px);
              > div {
                @include wh(100%, 100%);
                height: 100%;
                @include center;
                .drop {
                  @include wh(100%, 100%);
                  @include center;
                  // border-color: transparent;
                  border: 1px dashed rgb(217, 217, 217);
                  .msg {
                    @include center;
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    color: $font-color;
                    line-height: 20px;
                    flex-direction: column;
                    svg {
                      color: $warn-color;
                      @include font(38px);
                      width: 50px;
                      height: 50px;
                    }
                    p {
                      margin-top: 20px;
                    }
                    p:last-child {
                      font-size: 14px;
                      color: rgb(217, 217, 217);
                    }
                  }
                }
              }
              // 表格
              .el-table {
                border: 0 none;
                margin-top: 0;
                // padding-left: 15px;
                // height: calc(100% - 65px)!important;
                height: 100% !important;
                overflow: auto;
                // 普通表格 - 头部
                .el-table__header-wrapper {
                  .el-table__header {
                    colgroup.gutter {
                      // 表头与内容没对齐 @toCheck
                      display: table-cell !important;
                    }
                    .has-gutter {
                      // width: calc(100% - 5px);
                      tr {
                        th {
                          padding: 8px 0;
                          background: #f4f5f8;
                          border-color: #fff;
                          text-align: center;
                          .cell {
                            @include dot;
                            .table-head {
                              font-weight: normal;
                            }
                            .el-select {
                              .el-input {
                                .el-input__inner {
                                  text-align: center;
                                  background: #f4f5f8;
                                  border: none;
                                }
                              }
                            }
                          }
                        }
                        th.gutter {
                          // 表头与内容没对齐 @toCheck
                          display: table-cell !important;
                        }
                      }
                    }
                  }
                }
                // 普通表格 - 主体
                .el-table__body-wrapper {
                  // width: calc(100% - 5px);
                  .el-table__body {
                    tbody {
                      .el-table__row {
                        td {
                          // text-align: center;
                          border-color: #fff;
                          padding: 0;
                          .cell {
                            // height: 44px;
                            padding: 0;
                            @include dot;
                            .el-input {
                              vertical-align: middle;
                              .el-input__inner {
                                height: 24px;
                                line-height: 24px;
                              }
                            }
                            div {
                              line-height: 44px;
                              padding: 0 5px;
                              text-align: center;
                              @include dot;
                            }
                            .error {
                              background: $error-color;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              .el-table::before,
              .el-table::after {
                background: transparent;
              }
            }
          }
        }
        .page {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          height: 46px;
          .el-pagination {
            height: 100%;
            display: flex;
            align-items: center;
            .el-pagination__sizes {
              display: flex;
              align-items: center;
              height: 100%;
            }
          }
        }
      }
    }
    // 尾部
    .el-dialog__footer {
      height: 70px;
      padding: 0;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
      .dialog_footer {
        padding: 0 30px;
        @include wh(100%, 70px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .footer_search_box {
          display: flex;
          align-items: center;
          .el-button {
            height: 30px;
            padding: 0 10px;
          }
        }
        .footer_btns {
          .el-button {
            height: 30px;
            padding: 0 10px;
          }
        }
      }
    }
  }
}

// 媒体查询 @1440px
@media screen and (max-width: 1440px) {
  .el-dialog__wrapper.import_page {
    /deep/.el-dialog {
      @include wh(900px, 550px);
      .el-dialog__header {
        height: 36px;
        .reports_title_box {
          line-height: 36px;
          .reports_title {
            font-weight: bold;
            @include font(14px, 36px);
            .svg-icon {
              font-size: 16px;
            }
          }
          .reports_title_btn {
            .help {
              line-height: 36px;
            }
            .el-icon-close {
              line-height: 36px;
            }
          }
        }
      }
      .el-dialog__body {
        .content {
          .el-tabs {
            .el-tabs__header {
            }
            .el-tabs__content {
              .el-tab-pane {
                .el-table {
                  // 普通表格 - 头部
                  .el-table__header-wrapper {
                    .el-table__header {
                      colgroup.gutter {
                      }
                      .has-gutter {
                        tr {
                          th {
                            padding: 0 5px;
                            .cell {
                              line-height: 30px;
                              .table-head {
                              }
                            }
                          }
                          th.gutter {
                            // 表头与内容没对齐 @toCheck
                            display: table-cell !important;
                          }
                        }
                      }
                    }
                  }
                  // 普通表格 - 主体
                  .el-table__body-wrapper {
                    .el-table__body {
                      tbody {
                        .el-table__row {
                          td {
                            .cell {
                              div {
                                line-height: 30px;
                                padding: 0 5px;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                // 请选择Excel文件导入！
                > div {
                  .drop {
                    .msg {
                      svg {
                        font-size: 28px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        height: 56px;
        .dialog_footer {
          height: 56px;
        }
      }
    }
  }
}
// 媒体查询 @1024px
@media screen and (max-width: 1024px) {
  .el-dialog__wrapper.import_page {
    /deep/.el-dialog {
      @include wh(700px, 550px);
      // 尾部
      .el-dialog__footer {
        .dialog_footer {
          .footer_search_box {
            .el-input {
              width: 160px;
              height: 30px;
              .el-input__inner {
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
